import React, {Fragment} from 'react';
import PropTypes from 'prop-types';

// Components
import {Button, CheckBox, Table} from '@drivesally/sally-ui';
import StepFooter from '../../../layout/components/StepFooter/StepFooter';
import SmallLoader from '../../../layout/components/SmallLoader/SmallLoader';

// Columns
import columns from './columns';

// Lib
import displayTimeZoneSpecificDate from '../../../libs/displayTimeZoneSpecificDate';

// Types
import {dateTime} from '@drivesally/sally-fw/lib/type';

const SelectRentalStep = ({
  Container,
  loading,
  rental,
  rentals,
  onRental,
  onNext,
  onBack,
}) =>
  loading ? (
    <Container>
      <SmallLoader />
    </Container>
  ) : (
    <Fragment>
      <Container padding="none" noBorder>
        <Table columns={columns} noBorder noRadius smallNoResultsLabel>
          {(TableRow) =>
            [
              ...rentals.map((rentalToDisplay) => (
                <TableRow
                  key={rentalToDisplay.id}
                  onClick={onRental(rentalToDisplay)}
                >
                  {(TableColumn) => [
                    <TableColumn
                      key="vehicle"
                      span={2}
                      bold={rentalToDisplay.state === 'active'}
                    >
                      <CheckBox
                        value={rentalToDisplay.id === rental?.id}
                        onChange={() => null}
                        size="small"
                      />{' '}
                      {rentalToDisplay.vehicle.svid}
                    </TableColumn>,
                    <TableColumn
                      key="start"
                      bold={rentalToDisplay.state === 'active'}
                    >
                      {displayTimeZoneSpecificDate({
                        date: rentalToDisplay.start_date,
                        type: dateTime,
                        branch: rentalToDisplay?.sally_branch,
                      })}
                    </TableColumn>,
                    <TableColumn
                      key="end"
                      bold={rentalToDisplay.state === 'active'}
                    >
                      {!!rentalToDisplay.end_date
                        ? displayTimeZoneSpecificDate({
                            date: rentalToDisplay.end_date,
                            type: dateTime,
                            branch: rentalToDisplay?.sally_branch,
                          })
                        : '-'}
                    </TableColumn>,
                  ]}
                </TableRow>
              )),
            ].filter((row) => !!row)
          }
        </Table>
      </Container>
      <Container>
        <StepFooter
          left={
            <Button size="small" theme="grey" onClick={onBack}>
              Back
            </Button>
          }
          right={
            <Button size="small" onClick={onNext}>
              Next
            </Button>
          }
        />
      </Container>
    </Fragment>
  );

SelectRentalStep.propTypes = {
  Container: PropTypes.any,
  loading: PropTypes.bool,
  rental: PropTypes.object,
  rentals: PropTypes.array,
  onRental: PropTypes.func,
  onNext: PropTypes.func,
  onBack: PropTypes.func,
};

export default SelectRentalStep;
